import { DetailedHTMLProps, HTMLAttributes, memo, useMemo } from 'react';
import { components, OptionProps } from 'react-select';

import { ControlledSelectOption } from '../types/ControlledSelectOption';

const OptionComponent = <IsMulti extends boolean = false>({
  children,
  innerProps,
  ...props
}: OptionProps<ControlledSelectOption, IsMulti>) => {
  const innerPropsWithFocus = useMemo(
    () =>
      ({
        ...innerProps,
        'data-highlighted': props.isFocused ? 'true' : undefined,
      }) as DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    [props.isFocused, innerProps],
  );

  return (
    <components.Option {...props} innerProps={innerPropsWithFocus}>
      {children}
    </components.Option>
  );
};

export const Option = memo(OptionComponent) as typeof OptionComponent;
